const headers = {
  name: "Expenses",
  navigate: {
    path: [
      {
        name: "Expenses",
        path: "/app/expenses",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
